/**
 * atomberg-drag-scroll.js
 * ────────────────────────
 * Shared mouse drag-to-scroll behavior for horizontally scrollable rows
 * (ETR carousel, PDP color tiles, PDP thumbnail gallery). Short movements
 * (< threshold) are treated as clicks so tile/card/thumbnail buttons still work.
 */
(function () {
  /** @type {any} */
  var w = window;
  if (w._atombergDragScrollInit) return;
  w._atombergDragScrollInit = true;

  /**
   * Enable mouse drag-to-scroll on a single scrollable element.
   * @param {HTMLElement} el
   * @param {{dragClass?: string, threshold?: number}} [options]
   */
  function enable(el, options) {
    var opts = options || {};
    var dragClass = opts.dragClass || '';
    var threshold = opts.threshold || 5;

    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var hasDragged = false;

    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      hasDragged = false;
      startX = e.pageX - el.getBoundingClientRect().left;
      startScrollLeft = el.scrollLeft;
      el.style.scrollBehavior = 'auto';
      if (dragClass) el.classList.add(dragClass);
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - el.getBoundingClientRect().left;
      var delta = x - startX;
      if (Math.abs(delta) > threshold) hasDragged = true;
      if (hasDragged) el.scrollLeft = startScrollLeft - delta;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      if (dragClass) el.classList.remove(dragClass);
      el.style.scrollBehavior = '';

      // If the mouse moved enough to count as a drag, block the click that the
      // browser fires after mouseup — capture phase so it beats any delegated
      // document-level click listener (e.g. the PDP variant picker's).
      if (hasDragged) {
        el.addEventListener(
          'click',
          function blockClick(e) {
            e.preventDefault();
            e.stopPropagation();
            el.removeEventListener('click', blockClick, true);
          },
          true
        );
      }
    }

    document.addEventListener('mouseup', endDrag);
    document.addEventListener('mouseleave', endDrag);
  }

  w.AtombergDragScroll = { enable: enable };
})();
